import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostTemplateRequestType,
  PostTemplateResponseType,
} from '../types';

export const postTemplate = async ({
  pathParams: { organisationId, boardId },
  bodyParams,
}: PostTemplateRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/templates`;

  const { data } = await apiAuthClient.post<PostTemplateResponseType>(
    url,
    bodyParams,
  );

  return data.data;
};
